
export function getCreditCardPgeUrl() {
  // Get C6_STRIPE_URL from env
  const c6Url = window.env.REACT_APP_C6_URL;

  if (!c6Url) {
    throw new Error('REACT_APP_C6_URL is not defined');
  }

  const callbackUrl = document.URL;

  return `${c6Url}/payment/card?callback_url=${callbackUrl}&tool_name_id=PIXEL_ME`;
}
